<script lang="ts">
    import EditorStore from "@src/model/Editor.Store";
    import MainStore from "@src/model/Main.Store";
    import type { InteractionPoint } from "@src/model/Main.Store";
    
    import { afterUpdate, beforeUpdate, onDestroy, onMount } from "svelte";
import SingleInteractionIndicator from "./interact/SingleInteractionIndicator.svelte";
    
        let trackElem: HTMLDivElement;
        let subscribeList: any[] = [];

        let interactionPoints: InteractionPoint[] = [];
        $: interactionPoints = MainStore.getValue().currentInteractionPointList.getValue();
    
        onMount(() => {
            subscribeList.push(
                MainStore.getValue().currentVideoLength.subscribe((v) => {
                    let pxWidth = ((v || 0) / EditorStore.getSegmentLength()) * 100;
                    trackElem.style.setProperty('width', `${pxWidth}px`);
                }),
                EditorStore.getValue().currentTimelineSizingFactor.subscribe((v) => {
                    let pxWidth = ((MainStore.getValue().currentVideoLength.getValue() || 0) / EditorStore.getSegmentLength()) * 100;
                    trackElem.style.setProperty('width', `${pxWidth}px`);
                }),
                MainStore.getValue().currentInteractionPointList.subscribe((v: InteractionPoint[]) => {
                    interactionPoints = v;
                }),
            );
        });
        onDestroy(() => {
            subscribeList.forEach((v) => v());
        });
        
    </script>
    
    <div class="ivdemo-timeline-track" bind:this={trackElem}>
        {#each interactionPoints as interactionPoint}
            <SingleInteractionIndicator object={interactionPoint} />
        {/each}
    </div>
    
    
    <style>
        .ivdemo-timeline-track {
            background-color: #5f5f5f;
            border-bottom: 1px #9f9f9f solid;
            height: 16px;
            user-select: none;
            -webkit-user-select: none;
            width: 3000%;
        }
    </style>
    
    